import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import LeadFormPopup from './components/LeadFormPopup';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import OurAttorneys from './pages/OurAttorneys';
import ContactUs from './pages/ContactUs';
import ServiceDetailPage from './pages/ServiceDetailPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Header />
        <LeadFormPopup />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/attorneys" element={<OurAttorneys />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/services/corporate-business-contracts" element={<ServiceDetailPage serviceKey="corporate-business-contracts" />} />
          <Route path="/services/corporate-business-formation" element={<ServiceDetailPage serviceKey="corporate-business-formation" />} />
          <Route path="/services/business-transactions" element={<ServiceDetailPage serviceKey="business-transactions" />} />
          <Route path="/services/mergers-acquisitions" element={<ServiceDetailPage serviceKey="mergers-acquisitions" />} />
          <Route path="/services/non-profit-law" element={<ServiceDetailPage serviceKey="non-profit-law" />} />
          <Route path="/services/government-contracting" element={<ServiceDetailPage serviceKey="government-contracting" />} />
          <Route path="/services/business-disputes" element={<ServiceDetailPage serviceKey="business-disputes" />} />
          <Route path="/services/anti-corruption-compliance" element={<ServiceDetailPage serviceKey="anti-corruption-compliance" />} />
          <Route path="/services/immigration" element={<ServiceDetailPage serviceKey="immigration" />} />
          <Route path="/services/trademark-registration" element={<ServiceDetailPage serviceKey="trademark-registration" />} />
          <Route path="/services/copyright-registration" element={<ServiceDetailPage serviceKey="copyright-registration" />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
